import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useLanguage } from "../contexts/LanguageContext";
import { T } from "../i18n/strings";
import { ArticleCard } from "../components/ArticleCard";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const { lang } = useLanguage();
  const [input, setInput] = useState(q);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setInput(q);
    if (!q) { setResults([]); return; }
    setLoading(true);
    api.get("/articles", { params: { search: q, limit: 40 } })
      .then((r) => setResults(r.data))
      .finally(() => setLoading(false));
  }, [q]);

  const onSubmit = (e) => {
    e.preventDefault();
    setParams({ q: input });
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="search-page">
      <div className="pw-eyebrow">{T.labels.search[lang]}</div>
      <h1 className="font-serif-display text-4xl sm:text-5xl font-bold text-[#081422] mt-2 mb-8">
        {T.labels.searchResults[lang]}
      </h1>
      <form onSubmit={onSubmit} className="flex items-center gap-3 border-b-2 border-[#081422] pb-3 mb-8">
        <SearchIcon size={20} className="text-[#081422]" />
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={T.labels.search[lang]}
          className="flex-1 bg-transparent outline-none font-serif-display text-xl sm:text-2xl"
          data-testid="search-input"
          autoFocus
        />
        <button type="submit" className="pw-btn" data-testid="search-submit">{T.labels.search[lang]}</button>
      </form>

      {loading && <p className="font-mono-meta text-xs uppercase tracking-widest text-[#64748B]" data-testid="loading">Searching...</p>}
      {!loading && q && results.length === 0 && (
        <p className="font-serif-body text-lg text-[#475569]" data-testid="empty">{T.labels.noResults[lang]}</p>
      )}
      {!loading && results.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="search-results">
          {results.map((a) => <ArticleCard key={a.id} article={a} />)}
        </div>
      )}
    </div>
  );
}
